import { render } from "./NoHayIncidencias.vue?vue&type=template&id=f273ef7e"
import script from "./NoHayIncidencias.vue?vue&type=script&lang=js"
export * from "./NoHayIncidencias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__